import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { PackageService } from 'src/app/core/services/package.service';
import { WebApiService } from 'src/app/core/services/web-api.service';

import { IHotelItem } from 'src/app/shared/components/booking-hotel-card/booking-hotel-card.component';

@Injectable()
export class HotelsBookingProviderService {
  constructor(
    private readonly webApiService: WebApiService,
    private readonly packageService: PackageService,
  ) {}

  public getHotelsCollection(
    cityId: string,
    dates: {
      start: string;
      end: number;
    },
    payload?: {},
    itineraryIndex?: number,
  ): Observable<IHotelItem[]> {
    const f = new FormData();
    f.append('filters', JSON.stringify(payload));
    let correctDates: string = `${dates.start}-${dates.end}`;

    if (itineraryIndex >= 0) {
      const dateString: string =
        this.packageService.currentPackageDatesString[itineraryIndex];

      if (dateString) {
        correctDates = dateString;
      }
    }

    return this.webApiService
      .post('hotels/all', f, {
        key: this.packageService.currentPackageId,
        city: cityId,
        dates: correctDates,
      })
      .pipe(
        map((r) => {
          if (r && r.results && r.results.results) {
            return r.results.results.map((i: any) => {
              return { ...i, image: i.image[0], selected: false };
            });
          }
          return [];
        }),
      );
  }

  private cleanObject(formData: any) {
    const cleanedObj: Record<string, any> = {};

    Object.keys(formData).forEach((key) => {
      const val = formData[key];
      if (val !== undefined && val !== null) {
        if (val instanceof Array && val.length > 0) {
          cleanedObj[key] = val;
        }
      }
    });
    if (formData.priceRange) {
      if (formData.priceRange.min) {
        cleanedObj.priceRange = {
          min: formData.priceRange.min,
        };
      }
      if (formData.priceRange.max) {
        cleanedObj.priceRange.max = formData.priceRange.max;
      }
    }
    if (formData.sort) cleanedObj.sort = formData.sort;
    if (formData.score) cleanedObj.score = formData.score;
    if (formData.refundable) cleanedObj.refundable = formData.refundable;
    if (formData.breakfastIncluded)
      cleanedObj.breakfastIncluded = formData.breakfastIncluded;
    return cleanedObj;
  }
}
